export default "__VITE_ASSET__Oxcx7gyl__"